import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { getCurrentAdmin } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
  const [state, setState] = useState({ loading: true, admin: null });

  useEffect(() => {
    getCurrentAdmin().then((admin) => setState({ loading: false, admin }));
  }, []);

  if (state.loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-white">
        <Loader2 className="animate-spin text-[#ff6b35]" size={32} />
      </div>
    );
  }
  if (!state.admin) return <Navigate to="/admin/login" replace />;
  return typeof children === "function" ? children(state.admin) : children;
}
